import { getSectionByKey } from './publicPageContent'
import { resolveMediaUrl } from './mediaUrl'

export function field(section, key) {
  if (!section?.fields) return ''
  const value = section.fields[key]
  if (value == null) return ''
  return String(value).trim()
}

export function numbered(section, stem, suffixes, max = 40) {
  const items = []
  for (let i = 1; i <= max; i += 1) {
    const row = { index: i }
    let any = false
    for (const suffix of suffixes) {
      const value = field(section, `${stem}${i}${suffix}`)
      const name = suffix
        ? suffix.charAt(0).toLowerCase() + suffix.slice(1)
        : 'value'
      row[name] = value
      if (value) any = true
    }
    if (!any) break
    items.push(row)
  }
  return items
}

function mediaUrl(raw) {
  if (!raw) return ''
  const path = raw.url ?? raw.Url ?? ''
  return path ? resolveMediaUrl(path) : ''
}

export function mediaGroup(section, groupKey) {
  const groups = section?.media?.groups ?? section?.media?.Groups ?? {}
  const list =
    groups[groupKey] ??
    groups[groupKey?.charAt(0).toUpperCase() + groupKey?.slice(1)] ??
    []
  if (!Array.isArray(list)) return []
  return [...list]
    .sort(
      (a, b) =>
        Number(a.sortOrder ?? a.SortOrder ?? 0) -
        Number(b.sortOrder ?? b.SortOrder ?? 0)
    )
    .map((item) => ({
      id: item.id ?? item.Id,
      src: mediaUrl(item),
      alt: String(item.altText ?? item.AltText ?? ''),
      isPrimary: Boolean(item.isPrimary ?? item.IsPrimary),
      sortOrder: Number(item.sortOrder ?? item.SortOrder ?? 0),
    }))
    .filter((item) => item.src)
}

export function mediaSrc(section, groupKey) {
  const group = mediaGroup(section, groupKey)
  if (group.length) return group[0].src
  const primary = section?.media?.primary ?? section?.media?.Primary
  return mediaUrl(primary)
}

export function sectionOf(page, key) {
  return getSectionByKey(page, key)
}
